import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesReturnsMain } from './modules/ui/Main';

const ReturnsPage = (
  <SuspensePage>
    <PagesReturnsMain />
  </SuspensePage>
);

export default ReturnsPage;
